// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function StoredFiles() {
//   const [files, setFiles] = useState([]);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchFiles = async () => {
//       const token = localStorage.getItem("token");
//       try {
//         const res = await axios.get(`${API_BASE_URL}/api/files`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         setFiles(res.data);
//         setError("");
//       } catch (err) {
//         setError(err.response?.data?.error || "Failed to fetch stored files");
//       }
//     };
//     fetchFiles();
//   }, []);

//   const styles = {
//     container: {
//       padding: "20px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//       display: "flex",
//       alignItems: "center",
//     },
//     icon: {
//       fontSize: "28px",
//       marginRight: "8px",
//     },
//     tableContainer: {
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//       overflow: "hidden",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//     },
//     th: {
//       padding: "12px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: "600",
//       color: "#666",
//       backgroundColor: "#f8f8f8",
//       borderBottom: "2px solid #e0e0e0",
//       textTransform: "uppercase",
//     },
//     td: {
//       padding: "12px",
//       color: "#333",
//       borderBottom: "1px solid #e0e0e0",
//     },
//     rowHover: {
//       backgroundColor: "#f9f9f9",
//     },
//     empty: {
//       padding: "40px",
//       textAlign: "center",
//       color: "#666",
//       fontSize: "16px",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>
//         <span style={styles.icon}>📁</span> Stored Files
//       </h2>
//       <div style={styles.tableContainer}>
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>ID</th>
//               <th style={styles.th}>File Name</th>
//               <th style={styles.th}>Type</th>
//               <th style={styles.th}>Size (KB)</th>
//               <th style={styles.th}>Code</th>
//               <th style={styles.th}>Action</th>
//               <th style={styles.th}>Uploaded At</th>
//             </tr>
//           </thead>
//           <tbody>
//             {files.length > 0 ? (
//               files.map((f) => (
//                 <tr
//                   key={f.id}
//                   style={styles.td}
//                   onMouseOver={(e) => (e.currentTarget.style.backgroundColor = styles.rowHover.backgroundColor)}
//                   onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
//                 >
//                   <td style={styles.td}>{f.id}</td>
//                   <td style={styles.td}>{f.filename}</td>
//                   <td style={styles.td}>{f.mimetype || "—"}</td>
//                   <td style={styles.td}>{f.size ? (f.size / 1024).toFixed(2) : "—"}</td>
//                   <td style={styles.td}>{f.code}</td>
//                   <td style={styles.td}>{f.action_type || "—"}</td>
//                   <td style={styles.td}>{new Date(f.uploaded_at).toLocaleString()}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="7" style={styles.empty}>
//                   No stored files found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//       {error && <p style={styles.error}>{error}</p>}
//     </div>
//   );
// }

// export default StoredFiles;



// // Responsive StoredFiles Component

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function StoredFiles() {
//   const [files, setFiles] = useState([]);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchFiles = async () => {
//       const token = localStorage.getItem("token");
//       try {
//         const res = await axios.get(`${API_BASE_URL}/api/files`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         setFiles(res.data);
//         setError("");
//       } catch (err) {
//         setError(err.response?.data?.error || "Failed to fetch stored files");
//       }
//     };
//     fetchFiles();
//   }, []);

//   const styles = {
//     container: {
//       padding: "50px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//       marginLeft: "220px",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//       display: "flex",
//       alignItems: "center",
//     },
//     icon: {
//       fontSize: "28px",
//       marginRight: "8px",
//     },
//     tableContainer: {
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//       overflow: "auto",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       minWidth: "800px",
//     },
//     th: {
//       padding: "12px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: "600",
//       color: "#666",
//       backgroundColor: "#f8f8f8",
//       borderBottom: "2px solid #e0e0e0",
//       textTransform: "uppercase",
//     },
//     td: {
//       padding: "12px",
//       color: "#333",
//       borderBottom: "1px solid #e0e0e0",
//     },
//     rowHover: {
//       backgroundColor: "#f9f9f9",
//     },
//     empty: {
//       padding: "40px",
//       textAlign: "center",
//       color: "#666",
//       fontSize: "16px",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//   };

//   return (
//     <>
//       <style>
//         {`
//           @media (max-width: 768px) {
//             .stored-container {
//               margin-left: 0 !important;
//               padding: 15px !important;
//             }
            
//             .stored-heading {
//               font-size: 20px !important;
//               margin-top: 50px !important;
//             }
            
//             .table-container {
//               overflow-x: auto !important;
//             }
            
//             .stored-table {
//               font-size: 12px !important;
//             }
            
//             .stored-th {
//               padding: 10px !important;
//               font-size: 11px !important;
//             }
            
//             .stored-td {
//               padding: 10px !important;
//             }
//           }

//           @media (max-width: 480px) {
//             .stored-container {
//               padding: 12px !important;
//             }
            
//             .stored-heading {
//               font-size: 18px !important;
//             }
            
//             .stored-table {
//               font-size: 11px !important;
//             }
            
//             .stored-th {
//               padding: 8px !important;
//               font-size: 10px !important;
//             }
            
//             .stored-td {
//               padding: 8px !important;
//             }
            
//             .stored-icon {
//               font-size: 22px !important;
//             }
//           }
//         `}
//       </style>
//       <div className="stored-container" style={styles.container}>
//         <h2 className="stored-heading" style={styles.heading}>
//           <span className="stored-icon" style={styles.icon}>📁</span> Stored Files
//         </h2>
//         <div className="table-container" style={styles.tableContainer}>
//           <table className="stored-table" style={styles.table}>
//             <thead>
//               <tr>
//                 <th className="stored-th" style={styles.th}>ID</th>
//                 <th className="stored-th" style={styles.th}>File Name</th>
//                 <th className="stored-th" style={styles.th}>Type</th>
//                 <th className="stored-th" style={styles.th}>Size (KB)</th>
//                 <th className="stored-th" style={styles.th}>Code</th>
//                 <th className="stored-th" style={styles.th}>Action</th>
//                 <th className="stored-th" style={styles.th}>Uploaded At</th>
//               </tr>
//             </thead>
//             <tbody>
//               {files.length > 0 ? (
//                 files.map((f) => (
//                   <tr
//                     key={f.id}
//                     onMouseOver={(e) => (e.currentTarget.style.backgroundColor = styles.rowHover.backgroundColor)}
//                     onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
//                   >
//                     <td className="stored-td" style={styles.td}>{f.id}</td>
//                     <td className="stored-td" style={styles.td}>{f.filename}</td>
//                     <td className="stored-td" style={styles.td}>{f.mimetype || "—"}</td>
//                     <td className="stored-td" style={styles.td}>{f.size ? (f.size / 1024).toFixed(2) : "—"}</td>
//                     <td className="stored-td" style={styles.td}>{f.code}</td>
//                     <td className="stored-td" style={styles.td}>{f.action_type || "—"}</td>
//                     <td className="stored-td" style={styles.td}>{new Date(f.uploaded_at).toLocaleString()}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" style={styles.empty}>
//                     No stored files found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//         {error && <p style={styles.error}>{error}</p>}
//       </div>
//     </>
//   );
// }

// export default StoredFiles;





// paginated and responsive StoredFiles Component---table scrool no responsive


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function StoredFiles() {
//   const [files, setFiles] = useState([]);
//   const [error, setError] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const filesPerPage = 5;

//   useEffect(() => {
//     const fetchFiles = async () => {
//       const token = localStorage.getItem("token");
//       try {
//         const res = await axios.get(`${API_BASE_URL}/api/files`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         // ✅ Filter duplicate entries by (id + code)
//         const uniqueFiles = res.data.filter(
//           (v, i, a) => a.findIndex((t) => t.id === v.id && t.code === v.code) === i
//         );

//         setFiles(uniqueFiles);
//         setError("");
//       } catch (err) {
//         setError(err.response?.data?.error || "Failed to fetch stored files");
//       }
//     };
//     fetchFiles();
//   }, []);

//   // Pagination logic
//   const indexOfLastFile = currentPage * filesPerPage;
//   const indexOfFirstFile = indexOfLastFile - filesPerPage;
//   const currentFiles = files.slice(indexOfFirstFile, indexOfLastFile);
//   const totalPages = Math.ceil(files.length / filesPerPage);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber < 1 || pageNumber > totalPages) return;
//     setCurrentPage(pageNumber);
//   };

//   const styles = {
//     container: {
//       padding: "50px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//       marginLeft: "220px",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//       display: "flex",
//       alignItems: "center",
//     },
//     icon: {
//       fontSize: "28px",
//       marginRight: "8px",
//     },
//     tableContainer: {
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//       overflow: "auto",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       minWidth: "800px",
//     },
//     th: {
//       padding: "12px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: "600",
//       color: "#666",
//       backgroundColor: "#f8f8f8",
//       borderBottom: "2px solid #e0e0e0",
//       textTransform: "uppercase",
//     },
//     td: {
//       padding: "12px",
//       color: "#333",
//       borderBottom: "1px solid #e0e0e0",
//     },
//     rowHover: {
//       backgroundColor: "#f9f9f9",
//     },
//     empty: {
//       padding: "40px",
//       textAlign: "center",
//       color: "#666",
//       fontSize: "16px",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//     pagination: {
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       marginTop: "20px",
//       gap: "10px",
//       flexWrap: "wrap",
//     },
//     pageButton: {
//       padding: "8px 14px",
//       border: "1px solid #ccc",
//       borderRadius: "5px",
//       backgroundColor: "#fff",
//       cursor: "pointer",
//       fontSize: "14px",
//       color: "#333",
//       transition: "all 0.2s ease",
//     },
//     activePage: {
//       backgroundColor: "#007bff",
//       color: "#fff",
//       borderColor: "#007bff",
//     },
//     disabledButton: {
//       opacity: 0.5,
//       cursor: "not-allowed",
//     },
//   };

//   return (
//     <>
//       <style>
//         {`
//           @media (max-width: 768px) {
//             .stored-container {
//               margin-left: 0 !important;
//               padding: 15px !important;
//             }
//             .stored-heading {
//               font-size: 20px !important;
//               margin-top: 50px !important;
//             }
//             .table-container {
//               overflow-x: auto !important;
//             }
//             .stored-table {
//               font-size: 12px !important;
//             }
//             .stored-th {
//               padding: 10px !important;
//               font-size: 11px !important;
//             }
//             .stored-td {
//               padding: 10px !important;
//             }
//           }
//           @media (max-width: 480px) {
//             .stored-container {
//               padding: 12px !important;
//             }
//             .stored-heading {
//               font-size: 18px !important;
//             }
//             .stored-table {
//               font-size: 11px !important;
//             }
//             .stored-th {
//               padding: 8px !important;
//               font-size: 10px !important;
//             }
//             .stored-td {
//               padding: 8px !important;
//             }
//             .stored-icon {
//               font-size: 22px !important;
//             }
//           }
//         `}
//       </style>

//       <div className="stored-container" style={styles.container}>
//         <h2 className="stored-heading" style={styles.heading}>
//           <span className="stored-icon" style={styles.icon}>📁</span> Stored Files
//         </h2>

//         <div className="table-container" style={styles.tableContainer}>
//           <table className="stored-table" style={styles.table}>
//             <thead>
//               <tr>
//                 <th className="stored-th" style={styles.th}>ID</th>
//                 <th className="stored-th" style={styles.th}>File Name</th>
//                 <th className="stored-th" style={styles.th}>Type</th>
//                 <th className="stored-th" style={styles.th}>Size (KB)</th>
//                 <th className="stored-th" style={styles.th}>Code</th>
//                 <th className="stored-th" style={styles.th}>Action</th>
//                 <th className="stored-th" style={styles.th}>Uploaded At</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentFiles.length > 0 ? (
//                 currentFiles.slice(0, filesPerPage).map((f) => (
//                   <tr
//                     key={`${f.id}-${f.code}`}
//                     onMouseOver={(e) =>
//                       (e.currentTarget.style.backgroundColor =
//                         styles.rowHover.backgroundColor)
//                     }
//                     onMouseOut={(e) =>
//                       (e.currentTarget.style.backgroundColor = "#fff")
//                     }
//                   >
//                     <td className="stored-td" style={styles.td}>{f.id}</td>
//                     <td className="stored-td" style={styles.td}>{f.filename}</td>
//                     <td className="stored-td" style={styles.td}>{f.mimetype || "—"}</td>
//                     <td className="stored-td" style={styles.td}>
//                       {f.size ? (f.size / 1024).toFixed(2) : "—"}
//                     </td>
//                     <td className="stored-td" style={styles.td}>{f.code}</td>
//                     <td className="stored-td" style={styles.td}>{f.action_type || "—"}</td>
//                     <td className="stored-td" style={styles.td}>
//                       {new Date(f.uploaded_at).toLocaleString()}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" style={styles.empty}>No stored files found</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Controls */}
//         {files.length > filesPerPage && (
//           <div style={styles.pagination}>
//             <button
//               style={{
//                 ...styles.pageButton,
//                 ...(currentPage === 1 ? styles.disabledButton : {}),
//               }}
//               disabled={currentPage === 1}
//               onClick={() => handlePageChange(currentPage - 1)}
//             >
//               ◀ Prev
//             </button>

//             {Array.from({ length: totalPages }, (_, index) => (
//               <button
//                 key={index}
//                 style={{
//                   ...styles.pageButton,
//                   ...(currentPage === index + 1 ? styles.activePage : {}),
//                 }}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </button>
//             ))}

//             <button
//               style={{
//                 ...styles.pageButton,
//                 ...(currentPage === totalPages ? styles.disabledButton : {}),
//               }}
//               disabled={currentPage === totalPages}
//               onClick={() => handlePageChange(currentPage + 1)}
//             >
//               Next ▶
//             </button>
//           </div>
//         )}

//         {error && <p style={styles.error}>{error}</p>}
//       </div>
//     </>
//   );
// }

// export default StoredFiles;

// paginated and responsive StoredFiles Component---table scrool  responsive


import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

function StoredFiles() {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const filesPerPage = 5;

  useEffect(() => {
    const fetchFiles = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get(`${API_BASE_URL}/api/files`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // ✅ Filter duplicate entries by (id + code)
        const uniqueFiles = res.data.filter(
          (v, i, a) => a.findIndex((t) => t.id === v.id && t.code === v.code) === i
        );

        setFiles(uniqueFiles);
        setError("");
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch stored files");
      }
    };
    fetchFiles();
  }, []);

  // Pagination logic
  const indexOfLastFile = currentPage * filesPerPage;
  const indexOfFirstFile = indexOfLastFile - filesPerPage;
  const currentFiles = files.slice(indexOfFirstFile, indexOfLastFile);
  const totalPages = Math.ceil(files.length / filesPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // Format date based on screen size
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // Show only date on mobile: DD/MM/YYYY
      return date.toLocaleDateString();
    } else {
      // Show full date and time on desktop
      return date.toLocaleString();
    }
  };

  // Truncate text if longer than maxLength
  const truncateText = (text, maxLength = 15) => {
    if (!text) return "—";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const styles = {
    container: {
      padding: "50px",
      backgroundColor: "#f4f4f9",
      minHeight: "100vh",
      marginLeft: "220px",
      maxWidth: "100%",
      overflowX: "hidden",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "20px",
      display: "flex",
      alignItems: "center",
    },
    icon: {
      fontSize: "28px",
      marginRight: "8px",
    },
    tableContainer: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      overflowX: "auto",
      overflowY: "visible",
      WebkitOverflowScrolling: "touch",
      maxWidth: "100%",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "800px",
    },
    th: {
      padding: "12px",
      textAlign: "left",
      fontSize: "12px",
      fontWeight: "600",
      color: "#666",
      backgroundColor: "#f8f8f8",
      borderBottom: "2px solid #e0e0e0",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
    },
    td: {
      padding: "12px",
      color: "#333",
      borderBottom: "1px solid #e0e0e0",
      whiteSpace: "nowrap",
    },
    truncatedCell: {
      padding: "12px",
      color: "#333",
      borderBottom: "1px solid #e0e0e0",
      whiteSpace: "nowrap",
      cursor: "help",
      position: "relative",
    },
    rowHover: {
      backgroundColor: "#f9f9f9",
    },
    empty: {
      padding: "40px",
      textAlign: "center",
      color: "#666",
      fontSize: "16px",
      whiteSpace: "normal",
    },
    error: {
      marginTop: "15px",
      color: "#e53e3e",
      fontSize: "14px",
    },
    pagination: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "20px",
      gap: "10px",
      flexWrap: "wrap",
    },
    pageButton: {
      padding: "8px 14px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      backgroundColor: "#fff",
      cursor: "pointer",
      fontSize: "14px",
      color: "#333",
      transition: "all 0.2s ease",
    },
    activePage: {
      backgroundColor: "#007bff",
      color: "#fff",
      borderColor: "#007bff",
    },
    disabledButton: {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  };

  return (
    <>
      <style>
        {`
          /* Prevent body/html horizontal scroll */
          html, body {
            overflow-x: hidden !important;
            max-width: 100vw !important;
          }
          
          /* Container should not scroll horizontally */
          .stored-container {
            overflow-x: hidden !important;
            max-width: 100% !important;
          }
          
          /* Only table container scrolls */
          .table-container {
            overflow-x: auto !important;
            overflow-y: visible !important;
            -webkit-overflow-scrolling: touch;
            max-width: 100% !important;
            width: 100% !important;
          }
          
          .table-container::-webkit-scrollbar {
            height: 8px;
          }
          
          .table-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          
          .table-container::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
          }
          
          .table-container::-webkit-scrollbar-thumb:hover {
            background: #555;
          }

          @media (max-width: 768px) {
            .stored-container {
              margin-left: 0 !important;
              padding: 15px !important;
              overflow-x: hidden !important;
              max-width: 100vw !important;
            }
            .stored-heading {
              font-size: 20px !important;
              margin-top: 50px !important;
            }
            .stored-table {
              font-size: 12px !important;
            }
            .stored-th {
              padding: 10px !important;
              font-size: 11px !important;
            }
            .stored-td {
              padding: 10px !important;
            }
            .truncated-cell {
              padding: 10px !important;
            }
          }
          @media (max-width: 480px) {
            .stored-container {
              padding: 12px !important;
              overflow-x: hidden !important;
              max-width: 100vw !important;
            }
            .stored-heading {
              font-size: 18px !important;
            }
            .stored-table {
              font-size: 11px !important;
            }
            .stored-th {
              padding: 8px !important;
              font-size: 10px !important;
            }
            .stored-td {
              padding: 8px !important;
            }
            .truncated-cell {
              padding: 8px !important;
            }
            .stored-icon {
              font-size: 22px !important;
            }
          }
        `}
      </style>

      <div className="stored-container" style={styles.container}>
        <h2 className="stored-heading" style={styles.heading}>
          <span className="stored-icon" style={styles.icon}>📁</span> Stored Files
        </h2>

        <div className="table-container" style={styles.tableContainer}>
          <table className="stored-table" style={styles.table}>
            <thead>
              <tr>
                <th className="stored-th" style={styles.th}>ID</th>
                <th className="stored-th" style={styles.th}>File Name</th>
                <th className="stored-th" style={styles.th}>Type</th>
                <th className="stored-th" style={styles.th}>Size (KB)</th>
                <th className="stored-th" style={styles.th}>Code</th>
                <th className="stored-th" style={styles.th}>Action</th>
                <th className="stored-th" style={styles.th}>Uploaded At</th>
              </tr>
            </thead>
            <tbody>
              {currentFiles.length > 0 ? (
                currentFiles.map((f) => (
                  <tr
                    key={`${f.id}-${f.code}`}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        styles.rowHover.backgroundColor)
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#fff")
                    }
                  >
                    <td className="stored-td" style={styles.td}>{f.id}</td>
                    <td className="stored-td" style={styles.td}>{f.filename}</td>
                    <td 
                      className="truncated-cell stored-td" 
                      style={f.mimetype && f.mimetype.length > 15 ? styles.truncatedCell : styles.td}
                      title={f.mimetype || "—"}
                    >
                      {truncateText(f.mimetype, 15)}
                    </td>
                    <td className="stored-td" style={styles.td}>
                      {f.size ? (f.size / 1024).toFixed(2) : "—"}
                    </td>
                    <td className="stored-td" style={styles.td}>{f.code}</td>
                    <td className="stored-td" style={styles.td}>{f.action_type || "—"}</td>
                    <td className="stored-td" style={styles.td}>
                      {formatDate(f.uploaded_at)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={styles.empty}>No stored files found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {files.length > filesPerPage && (
          <div style={styles.pagination}>
            <button
              style={{
                ...styles.pageButton,
                ...(currentPage === 1 ? styles.disabledButton : {}),
              }}
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              ◀ Prev
            </button>

            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                style={{
                  ...styles.pageButton,
                  ...(currentPage === index + 1 ? styles.activePage : {}),
                }}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}

            <button
              style={{
                ...styles.pageButton,
                ...(currentPage === totalPages ? styles.disabledButton : {}),
              }}
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next ▶
            </button>
          </div>
        )}

        {error && <p style={styles.error}>{error}</p>}
      </div>
    </>
  );
}

export default StoredFiles;
